import { render, staticRenderFns } from "./taskView.vue?vue&type=template&id=0d215617&scoped=true&"
import script from "./taskView.vue?vue&type=script&lang=js&"
export * from "./taskView.vue?vue&type=script&lang=js&"
import style0 from "./taskView.vue?vue&type=style&index=0&id=0d215617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d215617",
  null
  
)

component.options.__file = "taskView.vue"
export default component.exports